import { computed } from "vue";

import { $t } from "@/i18n";
import { Routes } from "@/router";
import type { NavNode } from "@/utils/navUtils";

export function useUserSettingsNav() {
  const nav = computed<NavNode>(() => ({
    label: $t("common.label.userSettings"),
    icon: "phosphor/user-gear",
    layoutStoreKey: "userSettings",
    children: [
      {
        label: $t("common.label.profile"),
        layoutStoreKey: "profile",
        route: { name: Routes.USER_SETTINGS_PROFILE },
      },
      {
        label: $t("common.label.privateCategories"),
        layoutStoreKey: "privateCategories",
        route: { name: Routes.USER_SETTINGS_PRIVATE_CATEGORIES },
      },
    ],
  }));

  return nav;
}
